// @ts-check
import {
  getStudiesByDateRange,
  getStudyByID,
  downloadStudyZip as downloadStudyZipApi,
} from "../api/studies";
import StudyForList from "../models/studies/list";
import Study from "../models/studies/study";
import { VerifyJWT } from "../utils/jwtTools";

/**
 * @param {number} from
 * @param {number} to
 * @returns {Promise<StudyForList[]>}
 */
export async function getStudyList(from, to) {
  try {
    const res = await getStudiesByDateRange(from, to);
    const list = res.map((item) => new StudyForList(item));
    return list;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

/**
 * @param {number | string} ID
 * @returns {Promise<Study>}
 */
export async function getStudy(ID) {
  try {
    const res = await getStudyByID(ID);
    return new Study(res);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

/**
 * @param {string} token
 * @returns {Promise<Study>}
 */
export async function getStudyByToken(token) {
  try {
    const payload = VerifyJWT(token);
    if (!payload) {
      throw new Error("Token invalido");
    }
    // @ts-ignore
    const { ID } = payload;
    const res = await getStudyByID(ID);
    return new Study(res);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

/**
 * @param {string} uuid
 */
export function downloadStudyZip(uuid) {
  try {
    downloadStudyZipApi(uuid);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
